import { AccordionDetails, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField } from '@mui/material';
import React from 'react';
import '../conductStyles.scss';

const ECIRB: React.FunctionComponent<any> = ({
  imvChecklistPageData,
  handleCheck,
  isDisable,
  validationObj,
  disable
}) => {
  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checklist-radio-actions">
        <Grid md={12}>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Were all required IRB/EC submissions made promptly, e.g., amendments or annual updates?
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  value={validationObj.stdy_imvcl_irb_sub}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvcl_irb_sub"
                  onChange={e => handleCheck(e, 'section2')}
                >
                  <FormControlLabel
                    checked={validationObj.stdy_imvcl_irb_sub == 'Y' ? true : false}
                    disabled={!isDisable || disable}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    checked={validationObj.stdy_imvcl_irb_sub == 'N' ? true : false}
                    disabled={!isDisable || disable}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvcl_irb_sub_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvcl_irb_sub_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section2')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid md={12}>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Were all IRB/EC approvals or acknowledgements received since last visit reviewed for completeness and
              accuracy?Note any follow-up required.
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  value={imvChecklistPageData.enrollment_rate}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvcl_irb_approval"
                  onChange={e => handleCheck(e, 'section2')}
                >
                  <FormControlLabel
                    checked={validationObj.stdy_imvcl_irb_approval == 'Y' ? true : false}
                    disabled={!isDisable || disable}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    checked={validationObj.stdy_imvcl_irb_approval == 'N' ? true : false}
                    disabled={!isDisable || disable}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvcl_irb_approval_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvcl_irb_approval_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section2')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid md={12}>
          <Grid container mt={1} mb={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Grid item md={7}>
              Any pending IRB/EC approvals or documents?
            </Grid>
            <Grid item md={2}>
              <FormControl sx={{ display: 'flex', width: '140px' }}>
                <RadioGroup
                  sx={{ justifyContent: 'flex-end' }}
                  value={validationObj.stdy_imvcl_irb_pending}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stdy_imvcl_irb_pending"
                  onChange={e => handleCheck(e, 'section2')}
                >
                  <FormControlLabel
                    checked={validationObj.stdy_imvcl_irb_pending == 'Y' ? true : false}
                    disabled={!isDisable || disable}
                    value="Y"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    checked={validationObj.stdy_imvcl_irb_pending == 'N' ? true : false}
                    disabled={!isDisable || disable}
                    value="N"
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item md={3} sx={{ mt: -1.75 }}>
              <TextField
                name="stdy_imvcl_irb_pending_comm"
                label="Notes"
                variant="standard"
                value={validationObj.stdy_imvcl_irb_pending_comm}
                sx={{ mt: 0 }}
                onChange={e => handleCheck(e, 'section2')}
                disabled={!isDisable || disable}
                inputProps={{ maxLength: 2000 }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default ECIRB;
